(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jsc-bundle-set"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jsc-bundle-set')) {
    customElements.define('jsc-bundle-set', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.cards = Array.from(this.querySelectorAll('[data-bundle-card]'));
        this.addButton = this.querySelector('[data-bundle-add]');
        this.totalElement = this.querySelector('[data-bundle-total]');
        this.statusElement = this.querySelector('[data-bundle-status]');
        this.toast = this.querySelector('[data-bundle-toast]');
        this.toastOverlay = this.querySelector('[data-bundle-toast-overlay]');
        this.toastImage = this.querySelector('[data-bundle-toast-image]');
        this.dialog = this.querySelector('[data-dimensions-dialog]');
        this.dialogBody = this.querySelector('[data-dialog-body]');
        this.adding = false;
        this.toastTimer = null;

        this.cards.forEach((card) => {
          card.querySelectorAll('.jsc-bundle-set__swatch').forEach((swatch) => {
            swatch.addEventListener('click', () => this.selectProduct(card, swatch));
          });

          card.querySelectorAll('.jsc-bundle-set__option-value').forEach((value) => {
            value.addEventListener('click', () => this.selectOption(card, value));
          });

          const dimensionsTrigger = card.querySelector('[data-dimensions-trigger]');
          if (dimensionsTrigger) {
            dimensionsTrigger.addEventListener('click', () => this.openDimensions(card));
          }

          // Colour swatches and option values (e.g. size) start unselected.
          this.clearColorSelection(card);
        });

        this.addButton?.addEventListener('click', () => this.addToCart());
        this.querySelector('[data-dialog-close]')?.addEventListener('click', () => this.dialog.close());
        this.dialog?.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });
        this.updateTotal();

        if (!this.moneyReady()) {
          window.addEventListener('load', () => this.refreshPrices(), { once: true });
        }
      }

      moneyReady() {
        if (!window.theme || !window.theme.moneyFormat) return false;
        return typeof formatDisplayMoney === 'function' || typeof formatMoney === 'function';
      }

      clearColorSelection(card) {
        card.querySelectorAll('.jsc-bundle-set__swatch').forEach((swatch) => {
          swatch.classList.remove('is-active');
          swatch.setAttribute('aria-pressed', 'false');
        });
        delete card.dataset.variantId;
        delete card.dataset.price;
      }

      hasColorSelected(card) {
        return Boolean(card.querySelector('.jsc-bundle-set__swatch.is-active'));
      }

      hasRequiredOptionsSelected(card) {
        const picker = card.querySelector('[data-product-picker].is-active');
        if (!picker) return true;
        const groups = Array.from(picker.querySelectorAll('[data-option-position]'));
        if (!groups.length) return true;
        return groups.every((group) => {
          // Colour is chosen via swatches, not option buttons.
          if (group.hasAttribute('data-color-option')) return true;
          return Boolean(group.querySelector('.jsc-bundle-set__option-value.is-active'));
        });
      }

      isCardReady(card) {
        return this.hasColorSelected(card) && this.hasRequiredOptionsSelected(card) && Boolean(card.dataset.variantId);
      }

      isBundleComplete() {
        return this.cards.length > 0 && this.cards.every((card) => this.isCardReady(card));
      }

      refreshPrices() {
        this.cards.forEach((card) => {
          if (!this.hasColorSelected(card)) return;
          const activeId = card.querySelector('.jsc-bundle-set__swatch.is-active')?.dataset.productId;
          const product = this.getProduct(card, activeId);
          if (!product) return;
          const variant = product.variants.find((item) => String(item.id) === card.dataset.variantId);
          if (variant) this.applyVariant(card, product, variant);
        });
        this.updateTotal();
      }

      getProduct(card, productId) {
        if (!productId) return null;
        const data = card.querySelector(`[data-product-json="${productId}"]`);
        if (!data) return null;
        try {
          return JSON.parse(data.textContent);
        } catch (error) {
          return null;
        }
      }

      selectProduct(card, swatch) {
        if (swatch.disabled || swatch.classList.contains('is-unavailable')) return;
        const product = this.getProduct(card, swatch.dataset.productId);
        if (!product) return;

        card.querySelectorAll('.jsc-bundle-set__swatch').forEach((item) => {
          const active = item === swatch;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });

        card.querySelectorAll('[data-product-picker]').forEach((picker) => {
          const active = picker.dataset.productPicker === String(product.id);
          picker.classList.toggle('is-active', active);
          picker.hidden = !active;
        });

        const variant = this.resolveVariant(card, product);
        if (!variant) {
          delete card.dataset.variantId;
          delete card.dataset.price;
          this.updateOptionAvailability(card, product);
          this.updateTotal();
          return;
        }

        this.applyVariant(card, product, variant);
        if (this.isBundleComplete()) this.showCompletionToast();
      }

      selectOption(card, value) {
        if (value.disabled || value.classList.contains('is-unavailable')) return;
        const picker = value.closest('[data-product-picker]');
        const product = this.getProduct(card, picker?.dataset.productPicker);
        if (!picker || !product) return;

        const option = value.closest('[data-option-position]');
        option.querySelectorAll('.jsc-bundle-set__option-value').forEach((item) => {
          const active = item === value;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });

        // Size can be chosen visually before colour, but ATC stays locked until colour is set.
        if (!this.hasColorSelected(card)) {
          this.updateTotal();
          return;
        }

        const variant = this.resolveVariant(card, product, option, value);
        if (variant) this.applyVariant(card, product, variant);
        if (this.isBundleComplete()) this.showCompletionToast();
      }

      resolveVariant(card, product, changedOption, changedValue) {
        const picker = card.querySelector(`[data-product-picker="${product.id}"]`);
        if (!picker) {
          return product.variants.find((item) => item.available) || null;
        }

        const selected = Array.from(picker.querySelectorAll('[data-option-position]')).map((group) => {
          if (group.hasAttribute('data-color-option')) return null;
          return group.querySelector('.jsc-bundle-set__option-value.is-active')?.dataset.optionValue || null;
        });

        let variant = product.variants.find((item) => {
          if (!item.available) return false;
          return item.options.every((optionValue, index) => {
            if (selected[index] == null) return true;
            return optionValue === selected[index];
          });
        });

        if (!variant && changedOption && changedValue) {
          const position = Number(changedOption.dataset.optionPosition) - 1;
          variant = product.variants.find((item) => item.available && item.options[position] === changedValue.dataset.optionValue) || null;
        }

        if (!variant) {
          variant = product.variants.find((item) => item.available) || null;
        }

        return variant || null;
      }

      updateOptionAvailability(card, product) {
        const picker = card.querySelector(`[data-product-picker="${product.id}"]`);
        if (!picker) return;
        picker.querySelectorAll('[data-option-position]').forEach((group) => {
          const position = Number(group.dataset.optionPosition) - 1;
          group.querySelectorAll('.jsc-bundle-set__option-value').forEach((value) => {
            const available = product.variants.some((item) => item.available && item.options[position] === value.dataset.optionValue);
            value.classList.toggle('is-unavailable', !available);
            value.disabled = !available;
            value.setAttribute('aria-disabled', available ? 'false' : 'true');
            if (!available && value.classList.contains('is-active')) {
              value.classList.remove('is-active');
              value.setAttribute('aria-pressed', 'false');
            }
          });
        });
      }

      applyVariant(card, product, variant) {
        if (!this.hasColorSelected(card)) {
          delete card.dataset.variantId;
          delete card.dataset.price;
          this.updateTotal();
          return;
        }

        const image = card.querySelector('.jsc-bundle-set__image img');
        const imageSource = variant.featured_image?.src || product.featured_image;
        if (image && imageSource) {
          image.src = imageSource;
          image.srcset = '';
          image.alt = product.title;
        }

        const price = card.querySelector('[data-bundle-price]');
        const formattedPrice = this.formatMoney(variant.price);
        if (price && formattedPrice) price.textContent = formattedPrice;

        const dimensionsTrigger = card.querySelector('[data-dimensions-trigger]');
        if (dimensionsTrigger) {
          const hasDimensions = Boolean(card.querySelector(`[data-dimensions-template="${product.id}"]`));
          dimensionsTrigger.hidden = !hasDimensions;
          dimensionsTrigger.classList.toggle('hidden', !hasDimensions);
          dimensionsTrigger.dataset.productId = product.id;
        }

        this.updateOptionAvailability(card, product);

        if (this.hasRequiredOptionsSelected(card)) {
          card.dataset.variantId = variant.id;
          card.dataset.price = variant.price;
        } else {
          delete card.dataset.variantId;
          delete card.dataset.price;
        }

        this.updateTotal();
      }

      formatMoney(cents) {
        if (!this.moneyReady()) return '';

        if (typeof formatDisplayMoney === 'function') {
          try {
            return formatDisplayMoney(cents);
          } catch (error) {}
        }

        try {
          let formatted = formatMoney(cents, theme.moneyFormat).replace(/MYR\+?/gi, '').trim();
          const iso = theme.cartCurrencyIsoCode;
          if (iso === 'USD') formatted = formatted.replace(/(?<!US)\$/g, 'US$');
          else if (iso === 'SGD') formatted = formatted.replace(/(?<!S)\$/g, 'S$');
          return formatted;
        } catch (error) {
          return '';
        }
      }

      updateTotal() {
        const ready = this.isBundleComplete();
        const subtotal = this.cards.reduce((sum, card) => {
          if (!this.isCardReady(card)) return sum;
          return sum + (Number(card.dataset.price) || 0);
        }, 0);
        const discount = Number(this.dataset.discountPercentage) || 0;
        const total = Math.round(subtotal * (1 - discount * 0.01));
        if (this.totalElement) this.totalElement.textContent = ready ? this.formatMoney(total) : '';
        if (this.addButton) this.addButton.disabled = !ready || this.adding;
      }

      showCompletionToast() {
        if (!this.toast) return;

        // Prefer the merchant-set toast image; otherwise use the last selected product image.
        if (this.toastImage && !this.toast.hasAttribute('data-toast-has-image')) {
          const lastReadyCard = [...this.cards].reverse().find((card) => this.isCardReady(card));
          const sourceImage = lastReadyCard?.querySelector('.jsc-bundle-set__image img');
          if (sourceImage?.src) {
            this.toastImage.src = sourceImage.currentSrc || sourceImage.src;
            this.toastImage.alt = sourceImage.alt || '';
          }
        }

        window.clearTimeout(this.toastTimer);
        this.classList.add('is-toast-open');
        if (this.toastOverlay) {
          document.body.appendChild(this.toastOverlay);
          this.toastOverlay.hidden = false;
          // Allow fade-in transition after unhiding
          void this.toastOverlay.offsetWidth;
          this.toastOverlay.classList.add('is-visible');
        }
        if (!this.toast.isConnected || this.toast.parentElement !== document.body) {
          document.body.appendChild(this.toast);
        }
        this.toast.hidden = false;
        this.toast.classList.remove('is-leaving');
        this.toast.classList.remove('is-visible');
        // Restart CSS animation
        void this.toast.offsetWidth;
        this.toast.classList.add('is-visible');

        this.toastTimer = window.setTimeout(() => {
          this.toast.classList.remove('is-visible');
          this.toast.classList.add('is-leaving');
          this.classList.remove('is-toast-open');
          if (this.toastOverlay) this.toastOverlay.classList.remove('is-visible');
          window.setTimeout(() => {
            this.toast.classList.remove('is-leaving');
            this.toast.hidden = true;
            if (this.toastOverlay) this.toastOverlay.hidden = true;
          }, 300);
        }, 2200);
      }

      openDimensions(card) {
        const productId = card.querySelector('[data-dimensions-trigger]')?.dataset.productId;
        const template = card.querySelector(`[data-dimensions-template="${productId}"]`);
        if (!template || !this.dialog || !this.dialogBody) return;
        this.dialogBody.replaceChildren(template.content.cloneNode(true));
        this.dialog.showModal();
      }

      addToCart() {
        const mainId = Number(this.dataset.mainVariantId);
        if (this.adding || !mainId || !this.isBundleComplete()) return;
        if (typeof cartJSBulkAdd !== 'function') {
          if (this.statusElement) this.statusElement.textContent = this.dataset.cartError;
          return;
        }

        this.adding = true;
        this.addButton.setAttribute('aria-busy', 'true');
        this.updateTotal();
        const bundleSet = this.dataset.bundleSet || '';
        const bindID = mainId + '-' + new Date().getTime() / 1000;
        const items = [
          {
            id: mainId,
            quantity: 1,
            properties: {
              _MainProduct: 'Yes',
              _BindID: bindID
            }
          },
          ...this.cards.map((card) => ({
            id: Number(card.dataset.variantId),
            quantity: 1,
            properties: {
              _BindID: bindID,
              _BundleProduct: 'Yes',
              _BundleSet: bundleSet
            }
          }))
        ];
        const reset = () => {
          this.adding = false;
          this.addButton.removeAttribute('aria-busy');
          this.updateTotal();
        };

        if (window.jQuery) window.jQuery(document).one('cart.requestComplete', reset);
        window.setTimeout(reset, 5000);

        try {
          cartJSBulkAdd(items);
        } catch (error) {
          reset();
          if (this.statusElement) this.statusElement.textContent = this.dataset.cartError;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
